import { CardFooterItem } from "$components/card";
import { FormattedMessage } from "react-intl";

const ExpiredPrescriptionFooterItems = ({ prescribedBy }) => (
  <>
    <CardFooterItem
      label={
        <FormattedMessage
          id="patient.history.prescription.notDispensed.title"
          defaultMessage="Not Dispensed:"
        />
      }
    >
      <FormattedMessage
        id="patient.history.prescription.notDispensed.reason"
        defaultMessage="Expired"
      />
    </CardFooterItem>
    <CardFooterItem
      label={
        <FormattedMessage
          id="patient.history.prescription.notDispensed.prescribedBy"
          defaultMessage="Prescribed By:"
        />
      }
    >
      {prescribedBy}
    </CardFooterItem>
  </>
);

export { ExpiredPrescriptionFooterItems };
